import type { Breakpoint, Theme } from '@mui/material';

/** Icona dell'Alert (22px) più il suo margine (12px): il pulsante sotto parte dove parte il testo. */
const ALERT_ICON_COLUMN_PX = 34;

/**
 * Sul telefono il pulsante dell'Alert va sotto il testo, allineato al testo: accanto lo
 * schiaccerebbe in una colonna stretta. Per i contenitori stretti anche su desktop (pannello
 * assistente) si passa un breakpoint più alto.
 */
export function stackAlertActionBelowOnMobile(theme: Theme, breakpoint: Breakpoint = 'sm') {
  return {
    [theme.breakpoints.down(breakpoint)]: {
      flexWrap: 'wrap',
      // Il testo resta accanto all'icona: va a capo solo il pulsante.
      '& .MuiAlert-message': { flex: '1 1 0', minWidth: 0 },
      '& .MuiAlert-action': {
        flexBasis: '100%',
        marginLeft: 0,
        paddingLeft: `${ALERT_ICON_COLUMN_PX}px`,
        paddingTop: 0,
      },
    },
  };
}
